export default __webpack_public_path__ + "ad1255497c80c1f3f52e214cb26fc746.jpg";